import styled from 'styled-components';
import { Typography } from '../../../global/theme';

const ModalContent = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-16);
`;

const ModalForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
`;

const ModalInput = styled.input`
  padding: var(--space-12) var(--space-16);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  ${Typography.body_lg}
  color: var(--text-primary);
  outline: none;
  &:focus {
    border: 0.5px solid var(--border-primary);
    z-index: var(--z-index-999);
  }
  ::placeholder {
    color: var(--text-secondary);
  }
`;

const ModalButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-12);
`;

export { ModalContent, ModalForm, ModalInput, ModalButton };
